import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {UsersFilter} from './users-filter/UsersFilter.js';
import {UsersTable} from './users-table/UsersTable';
import {UsersFooter} from './users-footer/UsersFooter';
import FooterBar from '../../_common/components/FooterBar';

export function UsersCard() {

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'users-list-card'}>
      <UsersFilter/>
      <UsersTable/>
      <FooterBar>
        <UsersFooter/>
      </FooterBar>
    </Card>
  );
}
